import React, { useContext } from "react";
import { ThemeContext } from "../context/theme/theme"; 

const stylebtn = {
  border : 'None',
  borderRadius : '15px',
  cursor : 'pointer',
}
const stylebtnImg = {
  width : '2em',
  height:'2em'
}
const styleh1 = {
  fontSize :'10px',
  fontFamily:'Arial'
}
export  const Home =  () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const imgFilter = theme === "light" ? '/assets/img/icons8-dark-mode-64.png' : '/assets/img/icons8-light-on-48.png'

  return (
    <div className="app">
      <h1 style={styleh1}>{theme === "light" ? "Light Mode" : "Dark Mode"}</h1>
      <button onClick={toggleTheme} style={stylebtn}>
     <img src={imgFilter} alt="" style={stylebtnImg}/>
      </button>
    </div>
  );
};


